export default "__VITE_ASSET__Csm9bI4l__"